import React, { Component } from 'react'
import PersonalInformationSection from '../shared/personalInformationSection/PersonalInformationSection'
import PhoneSection from '../shared/phoneNumberSection/PhoneNumberSection'
import EmailSection from '../shared/emailSection/EmailSection'
import TermsAndConditionsSection from './TermsAndConditionsSection'
import PropTypes from 'prop-types'
import { trackEventMessage, trackEventMessageFailure } from '../../TelemetryService'
import PasswordSection from '../shared/passwordSection/PasswordSection'
import { Loading, Button } from 'carbon-components-react'
import { EventModel } from './../../models/EventModel'
import { REGISTER } from './../../constants'
import BuildDynamicMsg from '../shared/adaHelpers/BuildDynamicMsg'

export default class Register extends Component  {

    constructor() {
        super()
        this.state = {
            email: '',
            confirmEmail: '',
            validEmail: false,
            isEmailValidationLoading: false,
            firstName: '',
            lastName: '',
            validPI: false,
            loading: false,
            mobilePhoneNumber: '',
            validPhoneNumber: true,
            isPhoneNumberValidationLoading: false,
            acceptTermsAndConditions: false,
            loading: false,
            validPassword: false,
            password:'',
            passwordConfirmation:''
        }
        this.handleChangeAcceptTermsAndConditions = this.handleChangeAcceptTermsAndConditions.bind( this )
        this.handleSubmit = this.handleSubmit.bind( this )
        this.setPasswordIsValid = this.setPasswordIsValid.bind( this )
        this.setEmailIsValid = this.setEmailIsValid.bind( this )
        this.setEmailValues = this.setEmailValues.bind( this )
        this.setIsEmailValidationLoading = this.setIsEmailValidationLoading.bind( this )
        this.setPersonalInformationIsValid = this.setPersonalInformationIsValid.bind( this )
        this.setPersonalInformationIsValid = this.setPersonalInformationIsValid.bind( this )
        this.setPhoneNumberIsValid = this.setPhoneNumberIsValid.bind( this )
        this.setPhoneNumberValue = this.setPhoneNumberValue.bind( this )
        this.setIsPhoneValidationLoading = this.setIsPhoneValidationLoading.bind( this )
        this.setPasswordConfirmationValue = this.setPasswordConfirmationValue.bind( this )
        this.setPasswordIsValid = this.setPasswordIsValid.bind( this )
    }
    
    handleChangeAcceptTermsAndConditions = e => {
        this.setState( { acceptTermsAndConditions: e } )
    } 
   
    handleSubmit = ( enableSubmit ) =>{
        const { showConfirmation, showErrorMessage, handleSubmit } = this.props
        if( enableSubmit ) {
           
            const{ email, password, firstName, lastName, 
                confirmEmail, passwordConfirmation,acceptTermsAndConditions } = this.state
            this.setState( { loading: true } )
            handleSubmit( email, confirmEmail, this.phoneNumberFormatBeforePost(), password, passwordConfirmation, firstName, lastName, acceptTermsAndConditions )
            .then( data => {   
                this.setState( { loading: false } )
                window.scrollTo( 0, 0 )                
                if( !data )
                {
                    showErrorMessage()
                    trackEventMessageFailure( new EventModel( REGISTER.FAILURE, email ) )
                }else{                    
                    showConfirmation()
                    trackEventMessage( new EventModel( REGISTER.SUCCESS, email ) )
                }
            } )
            .catch( data => {
                window.scrollTo( 0, 0 )
                trackEventMessageFailure( new EventModel( REGISTER.FAILURE, email ), data )
                showErrorMessage()
            } )
        }
    }

    setPasswordIsValid =( isValid ) => {
        this.setState( { validPassword: isValid } )
    }

    setPasswordValue = ( password ) => {
        this.setState( { password: password } )
    }

    setPasswordConfirmationValue = ( passwordConfirmation ) => {
        this.setState( { passwordConfirmation: passwordConfirmation } )
    }

    setEmailIsValid =( validEmail ) => {
        this.setState( { validEmail: validEmail } )
    }

    setEmailValues = ( email, emailConfirmation ) => {    
        this.setState( { confirmEmail: emailConfirmation, email: email } )
    }

    setIsEmailValidationLoading = ( loading ) =>{
        this.setState( { isEmailValidationLoading: loading } )
    }

    setPersonalInformationIsValid =( validPI ) => {
        this.setState( { validPI: validPI } )
    }

    setPersonalInformationValues = ( firstName, lastName ) => {    
        this.setState( { firstName: firstName, lastName: lastName } )
    }
    
    setPhoneNumberValue =( mobilePhoneNumber ) => {
        this.setState( { mobilePhoneNumber: mobilePhoneNumber } )
    }

    setPhoneNumberIsValid = ( validPhoneNumber ) => {
        this.setState( { validPhoneNumber: validPhoneNumber } )
    }

    setIsPhoneValidationLoading = ( isPhoneNumberValidationLoading ) => {    
        this.setState( { isPhoneNumberValidationLoading: isPhoneNumberValidationLoading } )
    }

    phoneNumberFormatBeforePost = () => {
        const{ mobilePhoneNumber } = this.state
        return mobilePhoneNumber !== ( null || '' )
        ?`(${ mobilePhoneNumber.slice( 0, 3 ) }) ${ mobilePhoneNumber.slice( 4,7 ) } - ${ mobilePhoneNumber.slice( 8,12 ) }`
        :''
    }

    render() {
        const{ validPI, email, acceptTermsAndConditions, loading, validPassword, passwordConfirmation,
            password, validEmail, isEmailValidationLoading, validPhoneNumber, isPhoneNumberValidationLoading
        } = this.state

        const enableSubmit = ( validEmail && !isEmailValidationLoading &&  validPI
        && acceptTermsAndConditions && ( validPassword && password ) 
        && !isPhoneNumberValidationLoading &&  validPhoneNumber )
          
        const emailConfig =  {      
            inputWrapperClassName: 'c-form-email-section'
        }
        
        const confirmEmailConfig = {
            inputWrapperClassName: 'c-form-email-section'
        }
        
        const acceptTermsAndConditionsConfig =  {
            checked: acceptTermsAndConditions,
            onChange: this.handleChangeAcceptTermsAndConditions,
        }

        const passwordConfig = {
            className: 'c-form-input',
            inputWrapperClassName: ''
        }

        const passwordConfirmationConfig = {
            className: 'c-form-input',
            inputWrapperClassName: ''
        }
        const dynamicADAMsg = BuildDynamicMsg( validEmail, validPI, validPhoneNumber, validPassword, acceptTermsAndConditions )
        return (
            <>
                <main className="c-main sign-in">
                    <div className="os-container--max-width">
                        <div className="c-form-card" style={ { maxWidth: '100em' } }>
                            <div className="c-form-card__container">
                                <h1 className="o-heading-alpha" tabIndex="0">Sign Up</h1>
                                <h3 className="o-type-intro-p" tabIndex="0">View past bills and usage history (up to 36 months), set alerts, go paperless, pay online and more.</h3>
                            </div>
                            <div className="c-form-container-section">
                                <EmailSection
                                    emailConfig = { emailConfig }
                                    confirmEmailConfig = { confirmEmailConfig }
                                    dispalyToltip = { true }
                                    setEmailIsValid = { this.setEmailIsValid } 
                                    setEmailValues = { this.setEmailValues }
                                    setIsEmailValidationLoading = { this.setIsEmailValidationLoading }
                                />
                                <PersonalInformationSection
                                    setPersonalInformationIsValid = { this.setPersonalInformationIsValid } 
                                    setPersonalInformationValues = { this.setPersonalInformationValues }
                                    tittle = "Name"
                                />
                                <PhoneSection
                                    disabled = { this.props.disablePhoneNumber }
                                    setPhoneNumberValue = { this.setPhoneNumberValue } 
                                    setPhoneNumberIsValid = { this.setPhoneNumberIsValid }
                                    setIsPhoneValidationLoading = { this.setIsPhoneValidationLoading }
                                />
                                <PasswordSection
                                    passwordConfig = { passwordConfig }
                                    passwordConfirmationConfig = { passwordConfirmationConfig } 
                                    email = { email } 
                                    setPasswordIsValid = { this.setPasswordIsValid } 
                                    setPasswordValue = { this.setPasswordValue }
                                    setPasswordConfirmationValue = { this.setPasswordConfirmationValue }
                                    passwordValue = { password }
                                    passwordConfirmationValue = { passwordConfirmation }
                                    displayTitle =  { true }                                 
                                    displayBox =  { true }
                                    showInputComponentsInColum =  { true }                                 
                                    displayNotificacionBottom =  { true }  
                                    formInputsClass =  'c-form-container-in-column'                                    
                                    pswAriaLabel = "New password. Mandatory field. "
                                    pswConfariaLabel = "Re-enter password. "
                                    notification = {
                                        {
                                            contentWrapper: 'c-form-notification-box',
                                            visible: true
                                        }
                                    }
                                />
                                <TermsAndConditionsSection
                                    checkboxConfig = { acceptTermsAndConditionsConfig }
                                />
                                {
                                loading ?
                                    <Loading
                                        description= { null } className="center-spinner" withOverlay={ false } small = { true }
                                    />
                                    :
                                    <Button   
                                        className={ ` ${ enableSubmit ? 'c-btn c-btn--primary' : 'c-btn c-btn--disabled' } mb-5 c-btn--center-aligned` } 
                                        onClick={ () => this.handleSubmit( enableSubmit ) }
                                        tabIndex={ 0 }
                                        aria-label={ `Register Button ${ enableSubmit ? 'Enabled' : 'Disabled. ' + dynamicADAMsg } ` }
                                        data-testid="btn-Submit"                                        
                                    >
                                        Register
                                    </Button>
                               }
                            </div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}

Register.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    showConfirmation: PropTypes.func.isRequired,
    showErrorMessage: PropTypes.func.isRequired,
    disablePhoneNumber: PropTypes.bool,
}
